import React, { useState } from "react";
import axios from "axios";
import { Collapse, Button, message } from "antd";
import { CaretRightOutlined, InfoCircleOutlined, DownloadOutlined } from "@ant-design/icons";
import DragUpload from "../Form/DragUpload";
import { buildFilterParams } from "../../utils/filterParams";

const AccountManagerImport = ({ exportParams, onImported }) => {
  const [results, setResults] = useState();

  const handleExport = async () => {
    try {
      const query = buildFilterParams(exportParams).toString();
      await axios.get(`/api/account-manager-assignments/csv?${query}`);
      message.info("Please check the Export progress in System -> Jobs");
    } catch (error) {
      message.error(error.message);
    }
  };

  const handleUploadSuccess = (res) => {
    setResults(res.data.data);
    if (typeof onImported === "function") {
      onImported();
    }
  };

  const updated = results?.filter((result) => result.success && result.changed && result.action !== "removed") || [];
  const removed = results?.filter((result) => result.success && result.action === "removed") || [];
  const skipped = results?.filter((result) => result.success && !result.changed) || [];
  const failed = results?.filter((result) => !result.success) || [];

  return (
    <Collapse
      className="mb-2"
      expandIcon={({ isActive }) => (
        <CaretRightOutlined rotate={isActive ? 90 : 0} />
      )}
    >
      <Collapse.Panel header="Bulk Update Account Manager" key="bulk-update-account-manager">
        <div className="mb-2">
          <Button onClick={handleExport}>
            Download Account Manager CSV <DownloadOutlined />
          </Button>
        </div>
        <DragUpload
          action={`${process.env.REACT_APP_SERVER_URL}/api/account-manager-assignments/import`}
          accept=".xls, .xlsx, .csv"
          method="post"
          additionalDesc={`In the "Account Manager Email" column, enter an email to assign or change the manager, REMOVE to unassign, or leave blank for no change.`}
          onUploadSuccess={handleUploadSuccess}
        />
        {results && (
          <div className="mt-2">
            <Collapse
              size="small"
              expandIcon={({ isActive }) => (
                <CaretRightOutlined rotate={isActive ? 90 : 0} />
              )}
            >
              <Collapse.Panel
                header={
                  <span>
                    <InfoCircleOutlined /> Results of Last Import
                  </span>
                }
                key="last-import-result"
              >
                {updated.length > 0 && (
                  <>
                    <h4>
                      <strong>Updated ({updated.length})</strong>
                    </h4>
                    <ol>
                      {updated.map((result, index) => (
                        <li key={result.userId || index}>
                          {result.userId}: {result.email}
                          {result.auditRecorded === false && " — audit log not recorded"}
                        </li>
                      ))}
                    </ol>
                  </>
                )}
                {removed.length > 0 && (
                  <>
                    <h4>
                      <strong>Removed ({removed.length})</strong>
                    </h4>
                    <ol>
                      {removed.map((result, index) => (
                        <li key={result.userId || index}>
                          {result.userId}: was {result.email}
                          {result.auditRecorded === false && " — audit log not recorded"}
                        </li>
                      ))}
                    </ol>
                  </>
                )}
                <h4>
                  <strong>Failed ({failed.length})</strong>
                </h4>
                <ol>
                  {failed.map((result, index) => (
                    <li key={result.userId || index}>
                      {result.userId}: {result.message}
                    </li>
                  ))}
                </ol>
                {skipped.length > 0 && (
                  <>
                    <h4>
                      <strong>Skipped ({skipped.length})</strong>
                    </h4>
                    <ol>
                      {skipped.map((result, index) => (
                        <li key={result.userId || index}>
                          {result.userId}: {result.message}
                        </li>
                      ))}
                    </ol>
                  </>
                )}
              </Collapse.Panel>
            </Collapse>
          </div>
        )}
      </Collapse.Panel>
    </Collapse>
  );
};

export default AccountManagerImport;
